import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { Panel } from "primereact/panel";
import { AutoComplete } from "primereact/autocomplete";
import Server from "./../Server.js";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { connect } from "react-redux";
import { max } from "moment-jalaali";
import { Loader } from "rsuite";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Multiselect } from "multiselect-react-dropdown";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      layout: "list",
      GridDataUsers: [],
      GridDataFactors: [],
      visibleCreateUser: false,
      selectedUser: null,
      selectedUserId: null,
      levelFilter: null,
      level: "0",
      name: null,
      username: null,
      pass: null,
      pass2: null,
      address: null,
      mail: null,
      creditPrice: false,
      company: null,
      username: null,
      status: "1",
      map: null,
      mapList: [],
      PriceOfLevels: [],
      formuls: [],
      formul: null,
      formul_level: "",
      formul_off: "",
      formul_opr: "",
      PriceOfLevel: null,
      LevelOption: [],
      main: false,
      loading: 0,
      selectedSystem: [],
      permition: [],
      limit: 10,
      skip: 0,
      count: 0,
      first: 0,
      systemId: this.props.systemId || localStorage.getItem("systemId"),
    };

    this.CreateUser = this.CreateUser.bind(this);
    this.toast = React.createRef();
    this.onHide = this.onHide.bind(this);
    this.selectedUserChange = this.selectedUserChange.bind(this);
    this.handleChangeLevel = this.handleChangeLevel.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeMail = this.handleChangeMail.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeUsername = this.handleChangeUsername.bind(this);
    this.handleChangePass = this.handleChangePass.bind(this);
    this.handleChangePass2 = this.handleChangePass2.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeRaymandAcc = this.handleChangeRaymandAcc.bind(this);
    this.handleChangeRaymandUser = this.handleChangeRaymandUser.bind(this);

    this.SetOrEditUser = this.SetOrEditUser.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleChangeMap = this.handleChangeMap.bind(this);
  }

  getPermition(user_Id) {
    let param = {
      token: localStorage.getItem("api_token"),
      userId: user_Id,
      systemId: this.props.systemId
    };

    let that = this;
    let SCallBack = function (response) {
      const permition =
        response.data.result[0] && response.data.result[0].permitions["101"]
          ? response.data.result[0].permitions["101"]
          : [];
      that.setState({
        permition: permition,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getPermition", param, SCallBack, ECallBack);
  }

  GetMaps() {
    let that = this;
    this.setState({
      loading: 1,
    });
    let param = {
      token: localStorage.getItem("api_token"),
    };
    let SCallBack = function (response) {
      that.setState({
        mapList: response.data.result,
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/GetMaps", param, SCallBack, ECallBack);
  }

  SetOrEditUser() {
    let that = this;

    if (!this.state.username) {
      that.toast.current.show({
        severity: "warn",
        summary: "هشدار",
        detail: (
          <div>
            <span>نام کاربری را وارد کنید</span>
          </div>
        ),
        life: 8000,
      });

      return;
    }

    if (this.state.level == "1" && !this.state.ShopId) {
      that.toast.current.show({
        severity: "warn",
        summary: "هشدار",
        detail: (
          <div>
            <span>را انتخاب کنید فروشگاه</span>
          </div>
        ),
        life: 8000,
      });

      return;
    }

    this.setState({
      loading: 1,
    });
    let param = {
      _id: this.state.selectedUserId,
      token: localStorage.getItem("api_token"),
      name: this.state.name,
      mail: this.state.mail,
      creditPrice: this.state.creditPrice,
      username: this.state.username,
      level: this.state.level,
      status: this.state.status,
      address: this.state.address,
      ShopId: this.state.ShopId,
      insert: !this.state.selectedUserId,
      systemId: that.state.systemId,
      pass: that.state.pass,
      map: that.state.map,
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      if (response.data.error)
        that.toast.current.show({
          severity: "error",
          summary: "خطا",
          detail: (
            <div>
              <span>{response.data.result}</span>
            </div>
          ),
          life: 8000,
        });
      else {
        that.toast.current.show({
          severity: "success",
          summary: "پیغام موفقیت",
          detail: (
            <div>
              <span>عملیات با موفقیت انجام شد</span>
            </div>
          ),
          life: 8000,
        });

        that.GetUsers();
        that.setState({
          visibleCreateUser: false,
        });
      }
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطا",
        detail: (
          <div>
            <span>عملیات انجام نشد</span>
          </div>
        ),
        life: 8000,
      });
    };
    this.Server.send("AdminApi/ManageUsers", param, SCallBack, ECallBack);
  }
  handleChangeLevel(event) {
    this.setState({
      level: event.target.value,
      map: event.target.value == "1" ? this.state.mapList[0]?._id : null,
    });
  }
  handleChangeMail(event) {
    this.setState({ mail: event.target.value });
  }
  handleChangeCompany(event) {
    this.setState({ company: event.target.value });
  }
  handleChangeUsername(event) {
    this.setState({ username: event.target.value });
  }
  handleChangeName(event) {
    this.setState({ name: event.target.value });
  }
  handleChangePass(event) {
    this.setState({ pass: event.target.value });
  }
  handleChangePass2(event) {
    this.setState({ pass2: event.target.value });
  }
  handleChangeAddress(event) {
    this.setState({ address: event.target.value });
  }

  handleChangeRaymandAcc(event) {
    this.setState({ RaymandAcc: event.target.value });
  }
  handleChangeRaymandUser(event) {
    this.setState({ RaymandUser: event.target.value });
  }
  handleChangeStatus(event) {
    this.setState({ status: event.target.value });
  }
  handleChangeMap(event) {
    this.setState({ map: event.target.value });
  }

  onHide(event) {
    this.setState({
      visibleCreateUser: false,
      name: "",
      mail: "",
      creditPrice: false,
      company: "",
      level: "0",
      username: "",
      pass: "",
      pass2: "",
      address: "",
      RaymandAcc: "",
      RaymandUser: "",
      ShopId: this.state.main
        ? this.state.ShopArray && this.state.ShopArray[0]
        : this.state.ShopUserId,
      map: null,
      status: "1",
    });
  }
  CreateUser() {
    this.setState({
      name: "",
      username: "",
      pass: "",
      pass2: "",
      address: "",
      RaymandAcc: "",
      RaymandUser: "",
      visibleCreateUser: true,
      selectedUser: null,
      selectedUserId: null,
      map: this.state.mapList[0]?._id,
    });
  }
  selectedUserChange(value) {
    let that = this;
    this.setState({
      name: value.name,
      mail: value.mail,
      creditPrice: value.creditPrice,
      company: value.company,
      level: value.systemOfUser[0].level,
      username: value.username,
      address: value.address,
      ShopId: value.shopId,
      selectedUser: value.products,
      selectedUserId: value._id,
      status: value.systemOfUser[0].status,
      map: value.systemOfUser[0].map,
      map: value.systemOfUser[0].map
        ? value.systemOfUser[0].map
        : value.systemOfUser[0].level == "1"
        ? this.state.mapList[0]?._id
        : null,
      visibleCreateUser: true,
    });
  }
  componentDidMount() {
    let that = this;
    this.Server.send(
      "MainApi/checktoken",
      {
        token: localStorage.getItem("api_token"),
      },
      function (response) {
        that.setState({
          ShopUserId: response.data.authData.shopId,
          loading: 1,
        });
        that.GetShopList();
        that.getPermition(response.data.authData.userId);
      },
      function (error) {
        console.log(error);
      }
    );
  }

  GetShopList() {
    let that = this;
    let param = {};
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      let ShopArray = [],
        ShopArrayName = [];
      let main = false;
      for (let i = 0; i < response.data.result.length; i++) {
        ShopArray[i] = response.data.result[i]._id;
        ShopArrayName[i] = response.data.result[i].name;
        if (
          that.state.ShopUserId == response.data.result[i]._id &&
          response.data.result[i].main
        )
          main = true;
      }
      that.setState({
        ShopArray: ShopArray,
        ShopArrayName: ShopArrayName,
        ShopId: main ? ShopArray[0] : that.state.ShopUserId,
        main: main,
        loading: 0,
      });
    };
    let ECallBack = function (error) {};
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack);
  }
  GetUsers() {
    let that = this;
    this.setState({
      loading: 1,
    });

    let param = {
      token: localStorage.getItem("api_token"),
      userId: this.state.SearchValue ? this.state.SearchValue : null,
      ShopId: this.state.ShopUserId,
      GetAll: this.state.main ? 1 : 0,
      systemId: this.state.systemId,
      skip: this.state.skip,
    };
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
      });
      that.GetMaps();
      response.data.result.map(function (v, i) {
        const systemOfUser = v.systemOfUser[0];
        if (systemOfUser.level == "0") {
          v.level = "کاربر";
        } else {
          v.level = "مدیر / کارمند";
        }
        if (systemOfUser.status == "1") {
          v.status = "فعال";
        } else {
          v.status = "غیر فعال";
        }
        v.Radif = i + 1;
        v.edit = (
          <button
            className="btn btn-info irsans"
            onClick={() => that.selectedUserChange(v)}
          >
            ویرایش
          </button>
        );
      });
      that.setState({
        GridDataUsers: response.data.result,
        count: response.data.count,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getuser", param, SCallBack, ECallBack);
  }

  rowClass(data) {
    return {
      "row-highlight1": data.level != 1,
    };
  }

  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          _id={brand._id}
        >
          <div className="col-8" _id={brand._id} style={{ textAlign: "right" }}>
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              _id={brand._id}
            >
              <span style={{ whiteSpace: "pre-wrap" }} _id={brand._id}>
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }

  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });

    let param = {
      system: this.state.systemId,
      isMainSystem: true,
      title: event.query,
      table: "users",
      name: ["name", "username", "RaymandAcc", "RaymandUser"],
    };

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ _id: v._id, name: v.name });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }

  render() {
    let level = [
      { label: "همه", value: null },
      { label: "مدیر / کارمند", value: "مدیر" },
      { label: "کاربر", value: "کاربر" },
    ];

    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={() => this.SetOrEditUser()}
          style={{ width: "200px", marginTop: "5px", marginBottom: "5px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    return (
      <div style={{ direction: "rtl" }}>
        <div className="row justify-content-center mt-2">
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />

          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="مدیریت کاربران"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-success irsans"
                    onClick={this.CreateUser}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {" "}
                    ساخت کاربر جدید{" "}
                  </button>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-lg-6 col-12 mb-5"
                  style={{
                    background: "#fff",
                    textAlign: "right",
                    marginTop: 20,
                  }}
                >
                  <AutoComplete
                    placeholder="بخشی از نام / شماره موبایل / شناسه کاربری / شماره حساب  را جستجو کنید"
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      this.setState({
                        searchName: event.value,
                        SearchValue: null,
                      });
                    }}
                    itemTemplate={this.itemTemplate.bind(this)}
                    value={this.state.searchName}
                    onSelect={(event) => {
                      this.setState(
                        {
                          limit: 10,
                          skip: 0,
                          count: 0,
                          first: 0,
                          SearchValue: event.value._id,
                          searchName: event.value.name,
                        },
                        () => {
                          this.GetUsers();
                        }
                      );
                    }}
                    suggestions={this.state.brandSuggestions}
                    completeMethod={this.suggestBrands.bind(this)}
                  />
                </div>
                <div
                  className="col-lg-6 col-12 mb-5"
                  style={{
                    background: "#fff",
                    textAlign: "right",
                    marginTop: 20,
                  }}
                >
                  <button
                    className="btn btn-info irsans"
                    onClick={() => {
                      this.setState(
                        {
                          limit: 10,
                          skip: 0,
                          count: 0,
                          first: 0,
                        },
                        () => {
                          this.GetUsers();
                        }
                      );
                    }}
                  >
                    جستجو
                  </button>
                </div>
              </div>
              <DataTable
                rowClassName={this.rowClass}
                rows={this.state.limit}
                lazy
                onPage={(event) => {
                  console.log(event);
                  this.setState(
                    {
                      skip: event.page + 1,
                      first: event.first,
                    },
                    () => {
                      this.GetUsers();
                    }
                  );
                }}
                loading={this.state.loading}
                totalRecords={this.state.count}
                first={this.state.first}
                paginator={true}
                responsive
                ref={(el) => (this.dt = el)}
                value={this.state.GridDataUsers}
                selectionMode="single"
                selection={this.state.selectedUser}
                onSelectionChange={(e) => this.selectedUserChange(e.value)}
              >
                <Column
                  field="username"
                  header="نام کاربری"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="name"
                  header="نام"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="status"
                  header="وضعیت"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="level"
                  header="نوع"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                {this.state.main && (
                  <Column
                    field="map"
                    header="دسترسی"
                    className="irsans"
                    style={{ textAlign: "right" }}
                  />
                )}
              </DataTable>
            </Panel>
          </div>
        </div>
        <Dialog
          header={this.state.systemId ? "اصلاح" : "ساخت کاربر جدید"}
          visible={this.state.visibleCreateUser}
          width="800px"
          footer={footer}
          minY={70}
          maxY={400}
          onHide={this.onHide}
          maximizable={true}
        >
          <form
            style={{
              maxWidth: 800,
              maxHeight: 450,
              marginBottom: 10,
              maxWidth: 1000,
            }}
          >
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    disabled={this.state.selectedUserId}
                    value={this.state.username}
                    name="username"
                    onChange={this.handleChangeUsername}
                    required="true"
                  />
                  <label>نام کاربری</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.name}
                    name="name"
                    onChange={this.handleChangeName}
                    required="true"
                  />
                  <label>نام و نام خانوادگی</label>
                </div>
              </div>
              {!this.state.Raymand && (
                <div className="col-lg-12 col-12">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      style={{ direction: "ltr" }}
                      autoComplete="off"
                      type="text"
                      value={this.state.mail}
                      name="mail"
                      onChange={this.handleChangeMail}
                      required="true"
                    />
                    <label>پست الکترونیکی</label>
                  </div>
                </div>
              )}

              {!this.state.systemId && (
                <div className="col-lg-6">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      autoComplete="off"
                      type="password"
                      value={this.state.pass}
                      name="pass"
                      onChange={this.handleChangePass}
                      required="true"
                    />
                    <label>رمز عبور</label>
                  </div>
                </div>
              )}

              {!this.state.systemId && (
                <div className="col-lg-6">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      autoComplete="off"
                      type="password"
                      value={this.state.pass2}
                      name="pass2"
                      onChange={this.handleChangePass2}
                      required="true"
                    />
                    <label>تکرار رمز عبور</label>
                  </div>
                </div>
              )}

              {!this.state.selectedUserId && this.state.level == "1" && (
                <div className="col-lg-6">
                  <label className="labelNoGroup irsans">دسترسی</label>

                  <select
                    className="form-control irsans"
                    value={this.state.map}
                    name="map"
                    onChange={this.handleChangeMap}
                  >
                    {this.state.mapList &&
                      this.state.mapList.map((v, i) => {
                        if (this.state.main || !v.main)
                          return (
                            <option value={v._id}>{v.name || v._id}</option>
                          );
                      })}
                  </select>
                </div>
              )}
              <div className="col-lg-6" style={{ marginBottom: 10 }}>
                <label className="labelNoGroup irsans">وضعیت</label>

                <select
                  className="form-control irsans"
                  value={this.state.status}
                  name="status"
                  onChange={this.handleChangeStatus}
                >
                  <option value="1">فعال</option>
                  <option value="0">غیر فعال</option>
                </select>
              </div>
              <div className="col-lg-6" style={{ marginBottom: 10 }}>
                <label className="labelNoGroup irsans">سطح</label>

                <select
                  className="form-control irsans"
                  value={this.state.level}
                  name="status"
                  onChange={this.handleChangeLevel}
                >
                  <option value="0">کاربر</option>
                  <option value="1">مدیر</option>
                </select>
              </div>

              {this.state.level == "1" && (
                <div className="col-lg-6" style={{ textAlign: "center" }}>
                  <div>
                    <label className="labelNoGroup irsans">فروشگاه</label>
                    <select
                      className="form-control irsans"
                      value={this.state.ShopId}
                      name="ShopId"
                      onChange={(event) =>
                        this.setState({
                          ShopId: event.target.value,
                        })
                      }
                    >
                      <option value="null">
                        {" "}
                        فروشگاه مربوط به مدیر را انتخاب کنید
                      </option>
                      {this.state.ShopArray &&
                        this.state.ShopArray.map((v, i) => {
                          return (
                            <option value={v}>
                              {this.state.ShopArrayName[i]}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}

              {this.state.Raymand && (
                <div className="col-lg-6">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      autoComplete="off"
                      type="text"
                      value={this.state.RaymandUser}
                      name="RaymandUser"
                      onChange={this.handleChangeRaymandUser}
                      required="true"
                    />
                    <label>شماره مشتری صندوق قرض الحسنه</label>
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.address}
                    name="address"
                    onChange={this.handleChangeAddress}
                    required="true"
                  />
                  <label>آدرس کامل پستی</label>
                </div>
              </div>

              <div className="col-12" style={{ marginTop: 20 }}>
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: 0,
                  }}
                >
                  <Checkbox
                    inputId="creditPrice"
                    value={this.state.creditPrice}
                    checked={this.state.creditPrice}
                    onChange={(e) => this.setState({ creditPrice: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="creditPrice"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                    کاربر اعتبار نقدی
                  </label>
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Users);
